import { TLEventList } from '../lib/ab/event';
import { ABScreen } from '../lib/ab/screen';
import { aTrackPage } from '../lib/mdl/a-track';
import { legacyEventsGetProducerBySlug } from '../lib/mdl/zzz-legacy-open-events';
import { $el } from '../lib/ui/elements';
import { UIViewSpec } from '../lib/ui/view';
import { HomeMenu } from './menu';

export class HomeProducerScreen extends ABScreen {
    constructor(private _slug: string) {
        super({ menu: new HomeMenu });
    }

    protected override fillContent(content: UIViewSpec): void {
        legacyEventsGetProducerBySlug(this._slug).then(r => {
            const model = r.producer;

            content.ui_add($el.SECTION('w-block', [
                $el.P('bigtitle', model.name),
                $el.DIV('s-small'),
                new TLEventList('producer', 'list', 'event', r.events, { filter: 'active', sort: 'date' })
            ]));

            aTrackPage('producer', { producer: model.id });
        });
    }
}
